import React, { Component } from 'react';
import { Modal, Form, Grid, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import * as _ from 'lodash';
import moment from 'moment';
import {
  DEFAULT_RUN_ENGINE_SETTINGS,
  EditMode,
  // DEFAULT_PLANNING_ENGINE_SETTINGS,
} from '../../../HelperMethods/constants';
import EngineParameters from '../TaskViewPage/EngineParameters';
import EngineRunCheckModal from './EngineRunCheckModal';
import { permissionCheck } from '../TaskViewPage/helper';

class SettingsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scoreCoefficient: _.get(
        this.props,
        'engineSettings.scoreCoefficient',
        DEFAULT_RUN_ENGINE_SETTINGS.scoreCoefficient
      ),
      timeLimit: _.get(this.props, 'engineSettings.timeLimit', DEFAULT_RUN_ENGINE_SETTINGS.timeLimit),
      highScoreThreshold: _.get(
        this.props,
        'engineSettings.highScoreThreshold',
        DEFAULT_RUN_ENGINE_SETTINGS.highScoreThreshold
      ),
      highScoreCoefficient: _.get(
        this.props,
        'engineSettings.highScoreCoefficient',
        DEFAULT_RUN_ENGINE_SETTINGS.highScoreCoefficient
      ),
      enableClustering: _.get(
        this.props,
        'engineSettings.enableClustering',
        DEFAULT_RUN_ENGINE_SETTINGS.enableClustering
      ),
      enableGroupClustering: _.get(
        this.props,
        'engineSettings.enableGroupClustering',
        DEFAULT_RUN_ENGINE_SETTINGS.enableGroupClustering
      ),
      unassignUsers: _.get(this.props, 'engineSettings.unassignUsers', DEFAULT_RUN_ENGINE_SETTINGS.unassignUsers),
      balanceTechTimeCoefficient: _.get(
        this.props,
        'engineSettings.balanceTechTimeCoefficient',
        DEFAULT_RUN_ENGINE_SETTINGS.balanceTechTimeCoefficient
      ),
      useCrowFlyDistances: _.get(
        this.props,
        'engineSettings.useCrowFlyDistances',
        DEFAULT_RUN_ENGINE_SETTINGS.useCrowFlyDistances
      ),
      crowFlyDistanceFactorPercentage: _.get(
        this.props,
        'engineSettings.crowFlyDistanceFactorPercentage',
        DEFAULT_RUN_ENGINE_SETTINGS.crowFlyDistanceFactorPercentage
      ),
      disableTechEndLocation: _.get(
        this.props,
        'engineSettings.disableTechEndLocation',
        DEFAULT_RUN_ENGINE_SETTINGS.disableTechEndLocation
      ),
      balanceTechShiftUtilization: _.get(
        this.props,
        'engineSettings.balanceTechShiftUtilization',
        DEFAULT_RUN_ENGINE_SETTINGS.balanceTechShiftUtilization
      ),
      disableAvailabilityRestriction: _.get(
        this.props,
        'engineSettings.disableAvailabilityRestriction',
        DEFAULT_RUN_ENGINE_SETTINGS.disableAvailabilityRestriction
      ),
      timeBuffer: _.get(this.props, 'engineSettings.timeBuffer', DEFAULT_RUN_ENGINE_SETTINGS.timeBuffer),
      useUserLocation: _.get(this.props, 'engineSettings.useUserLocation', DEFAULT_RUN_ENGINE_SETTINGS.useUserLocation),
      hideAdvancedSettings: false,
      planningStartDate: this.props.planningStartDate,
      planningEndDate: this.props.planningEndDate,
      planningBaseTime: this.props.planningBaseTime,
      startTimeLte: _.get(this.props, 'engineSettings.startTimeLte', DEFAULT_RUN_ENGINE_SETTINGS.startTimeLte),
      autoFreezTimeLte: '', // this should always be fresh
      startDateLte: this.props.startDateLte,
      maxStartDateLte: this.props.maxStartDateLte,
      planningMaxDate: this.props.planningMaxDate,
      runEngineCheckModal: false,
      validation: {},
    };

    this.onChange = this.onChange.bind(this);
    this.validatePlanningStartEndDate = this.validatePlanningStartEndDate.bind(this);

    if (this.props.planningModeModalOpen) {
      this.state = {
        ...this.state,
        // ...DEFAULT_PLANNING_ENGINE_SETTINGS,
        hideAdvancedSettings: true,
        planningEndDateError: false,
      };
    }
  }

  onChange(event) {
    const field = event.target.name;
    const { value } = event.target;
    let planningEndDateError = false;
    let planningMaxDate;

    if (field === 'planningStartDate') {
      planningMaxDate = moment(value)
        .add(this.props.maxPlanningDays - 1, 'days')
        .format('YYYY-MM-DD');
      planningEndDateError = !this.validatePlanningStartEndDate(value, this.state.planningEndDate);
    } else if (field === 'planningEndDate') {
      planningEndDateError = !this.validatePlanningStartEndDate(this.state.planningStartDate, value);
    } else {
      planningEndDateError = !this.validatePlanningStartEndDate(
        this.state.planningStartDate,
        this.state.planningEndDate
      );
    }
    planningMaxDate = planningMaxDate || this.state.planningMaxDate;

    this.setState({
      [field]: value,
      planningEndDateError,
      planningMaxDate,
    });
  }

  onEngineParameterChange = (field, value) => {
    let errorObj = {};
    if (field === 'startDateLte') {
      if (moment(value) > moment(this.props.maxStartDateLte)) {
        errorObj = { startDateLte: 'Selected Date is greater than allowed date' };
      }
      this.setState({
        validation: errorObj,
      });
    }
    this.setState({
      [field]: value,
    });
  };

  engineRunCheck = (tasksEditMode) => {
    if (tasksEditMode === EditMode.UNPUBLISHED) {
      this.setState({ runEngineCheckModal: true });
      return false;
    }
    return true;
  };

  disabelCheckforEngineParameters = (planningModalState, permission) => {
    if (!planningModalState) {
      return !permission;
    }
    return false;
  };

  validatePlanningStartEndDate(planningStartDate, planningEndDate) {
    const startDate = planningStartDate || this.state.planningStartDate;
    const endDate = planningEndDate || this.state.planningEndDate;

    if (startDate && endDate && new Date(endDate).getTime() >= new Date(startDate).getTime()) {
      return true;
    }

    return false;
  }

  runPlanningOrDailyEngine() {
    if (!this.props.planningModeModalOpen) {
      this.props.saveSettings(true, this.state);
    } else if (this.validatePlanningStartEndDate()) {
      const engineSettingsForPlanning = this.props.evaluateEngineSettings(this.state);
      this.props.close(this.props.toggleModalStateKey, false, false);
      const planningStartDate = moment(this.state.planningStartDate).startOf('day').add(this.state.planningBaseTime);
      const planningEndDate = moment(this.state.planningEndDate)
        .startOf('day')
        .add(this.state.planningBaseTime)
        .add(24 * 60, 'minutes')
        .subtract(1, 'seconds');
      const currentPlanningStartTime = moment(this.state.planningStartDate)
        .startOf('day')
        .add(this.state.planningBaseTime);
      const currentPlanningEndTime = moment(this.state.planningStartDate)
        .startOf('day')
        .add(this.state.planningBaseTime)
        .add(24 * 60, 'minutes')
        .subtract(1, 'seconds');
      this.props.planningEngine(
        engineSettingsForPlanning,
        currentPlanningStartTime.format('YYYY-MM-DD'),
        planningStartDate,
        planningEndDate,
        currentPlanningStartTime,
        currentPlanningEndTime
      );
    } else {
      this.setState({
        planningEndDateError: true,
      });
    }
  }

  render() {
    return (
      <div>
        <Modal
          className="custom-settings-modal"
          size={this.props.size}
          open={this.props.open}
          onClose={() => {
            this.props.close(this.props.toggleModalStateKey, false, true);
          }}
          centered
        >
          <Modal.Header>
            {this.props.planningModeModalOpen ? 'Planning ' : 'Tasks '}
            Engine Settings
          </Modal.Header>
          <Modal.Content>
            <Form autoComplete="off">
              {this.props.planningModeModalOpen && (
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <Form.Field inline>
                        <label>Planning Start Date</label>
                        <input
                          className="date-input-with-sematic"
                          style={{ width: '100%' }}
                          type="date"
                          min={this.props.planningMinDate}
                          value={this.state.planningStartDate}
                          name="planningStartDate"
                          onChange={(event) => {
                            this.onChange(event);
                          }}
                        />
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column>
                      <Form.Field inline>
                        <label>Planning End Date</label>
                        <input
                          className="date-input-with-sematic"
                          type="date"
                          style={{ width: '100%' }}
                          min={this.state.planningStartDate}
                          max={this.state.planningMaxDate}
                          value={this.state.planningEndDate}
                          name="planningEndDate"
                          onChange={(event) => {
                            this.onChange(event);
                          }}
                        />
                        {this.state.planningEndDateError && (
                          <div className="errorText" style={{ paddingLeft: '0px', marginTop: '5px' }}>
                            End date must be on or after the start date.
                          </div>
                        )}
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <Form.Field inline>
                        <label>Planning Base Time</label>
                        <input
                          className="date-input-with-sematic"
                          style={{ width: '100%' }}
                          type="time"
                          // min={this.props.planningStartTime}
                          value={this.state.planningBaseTime}
                          name="planningBaseTime"
                          onChange={(event) => {
                            this.onChange(event);
                          }}
                        />
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={1}>
                    <Grid.Column>
                      <Form.Field inline>
                        {this.state.hideAdvancedSettings ? (
                          <i
                            style={this.checkBoxStyle}
                            className="fa fa-square ag-grid-checkbox"
                            onClick={() => {
                              this.setState((state) => ({
                                hideAdvancedSettings: !state.hideAdvancedSettings,
                              }));
                            }}
                          />
                        ) : (
                          <i
                            style={this.checkBoxStyle}
                            className="fa fa-check-square ag-grid-checkbox"
                            onClick={() => {
                              this.setState((state) => ({
                                hideAdvancedSettings: !state.hideAdvancedSettings,
                              }));
                            }}
                          />
                        )}
                        <label
                          style={this.labelStyleCheckBox}
                          onClick={() => {
                            this.setState((state) => ({
                              hideAdvancedSettings: !state.hideAdvancedSettings,
                            }));
                          }}
                        >
                          Advanced Settings
                        </label>
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              )}
              {!this.state.hideAdvancedSettings && (
                <EngineParameters
                  onEngineParameterChange={this.onEngineParameterChange}
                  parameters={this.state}
                  planningModeModalOpen={this.props.planningModeModalOpen}
                  taskViewEngineSettingsManagement
                  validation={this.state.validation}
                />
              )}
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Grid>
              <Grid.Row className="form-button-row settings-footer" style={{ marginTop: '10px' }}>
                <Grid.Column width={16}>
                  <Button
                    primary
                    style={{ display: !this.props.planningModeModalOpen ? 'none' : 'block' }}
                    disabled={this.disabelCheckforEngineParameters(
                      this.props.planningModeModalOpen,
                      permissionCheck('saveEngineSetting', this.props.loggedInUser)
                    )}
                    floated="right"
                    type="button"
                    onClick={() => {
                      if (this.engineRunCheck(this.props.tasksEditMode)) {
                        this.runPlanningOrDailyEngine();
                      }
                    }}
                  >
                    {this.props.planningModeModalOpen ? 'Plan' : 'Save & Run'}
                  </Button>
                  {!this.props.planningModeModalOpen && (
                    <>
                      <Button
                        primary
                        floated="right"
                        type="button"
                        onClick={() => {
                          if (this.engineRunCheck(this.props.tasksEditMode)) {
                            // params are, runEngine, settingsModalState, shouldModalclose = true
                            this.props.saveSettings(true, this.state, true);
                          }
                        }}
                        disabled={Object.keys(this.state.validation || {}).length}
                      >
                        Run
                      </Button>
                      <Button
                        primary
                        floated="right"
                        type="button"
                        disabled={
                          this.disabelCheckforEngineParameters(
                            this.props.planningModeModalOpen,
                            permissionCheck('saveEngineSetting', this.props.loggedInUser)
                          ) || Object.keys(this.state.validation || {}).length
                        }
                        onClick={() => {
                          // params are, runEngine, settingsModalState, shouldModalclose = true
                          this.props.saveSettings(false, this.state, false);
                        }}
                      >
                        Save
                      </Button>
                    </>
                  )}
                  <Button
                    basic
                    floated="right"
                    type="button"
                    onClick={() => {
                      this.props.close(this.props.toggleModalStateKey, false, true);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {/* <Button negative onClick={this.props.close}>Cancel</Button>
                    <Button positive labelPosition='right' content='Save' onClick={this.props.saveSettings} /> */}
          </Modal.Actions>
        </Modal>
        <EngineRunCheckModal
          open={this.state.runEngineCheckModal}
          onYesClick={async () => {
            await this.props.onDiscardPublish();
            this.setState({ runEngineCheckModal: false });
            this.runPlanningOrDailyEngine();
          }}
          onNoClick={() => this.setState({ runEngineCheckModal: false })}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    engineSettings: state.appReducer.selectedRunEngineSettings,
    planningStartDate: state.taskViewPageReducer.planningStartDate,
    planningEndDate: state.taskViewPageReducer.planningEndDate,
    planningBaseTime: state.taskViewPageReducer.planningBaseTime,
    startDateLte: state.taskViewPageReducer.startDateLte,
    maxStartDateLte: state.taskViewPageReducer.startDateLte,
    planningMaxDate: state.taskViewPageReducer.planningMaxDate,
    planningMinDate: state.taskViewPageReducer.planningMinDate,
    maxPlanningDays: state.taskViewPageReducer.maxPlanningDays,
    tasksEditMode: state.taskViewPageReducer.tasksEditMode,
    loggedInUser: state.appReducer.loggedInUser,
  };
}
SettingsModal.propTypes = {
  onDiscardPublish: PropTypes.func.isRequired,
  planningStartDate: PropTypes.string.isRequired,
  planningEndDate: PropTypes.string.isRequired,
  planningBaseTime: PropTypes.string.isRequired,
  startDateLte: PropTypes.string.isRequired,
  maxStartDateLte: PropTypes.string.isRequired,
  planningMaxDate: PropTypes.string.isRequired,
  planningMinDate: PropTypes.string.isRequired,
  maxPlanningDays: PropTypes.number.isRequired,
  loggedInUser: PropTypes.object,
  close: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
  toggleModalStateKey: PropTypes.any,
  planningModeModalOpen: PropTypes.bool.isRequired,
  saveSettings: PropTypes.func.isRequired,
  evaluateEngineSettings: PropTypes.func.isRequired,
  planningEngine: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  tasksEditMode: PropTypes.string,
};
export default connect(mapStateToProps, null)(SettingsModal);
